import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Resource} from '../../../graphql/resources.datatypes';
import {gqlPaginatorInfo, PaginatiorInfo} from '../../../graphql/common.datatypes';

interface ResourcesData {
    resources: {
        data: Resource[],
        paginatorInfo: PaginatiorInfo,
    }
}

export const GET_RESOURCES_QUERY = gql`
  query resources($count: Int!, $page: Int!, $where: WhereConditions, $orderBy: [OrderByClause!]){
    resources(first: $count, page: $page, where: $where, orderBy: $orderBy){
      data {
          id
          internal_name
          display_name
          resource_type
      }
      ${gqlPaginatorInfo}
    }
  }
`;

export const getResources = (count: number, page: number, where?: any, orderBy?: any, ) => useQuery<ResourcesData>(
  GET_RESOURCES_QUERY,
  {
    variables: {
        count,
        page,
        where,
        orderBy,
    },
  }
);

export default getResources;
